export default __webpack_public_path__ + "static/media/icon-alarm_clock.c517387b.png";